<template>
    <a class="button is-primary" @click="submitForm" :class="{ 'is-loading' : isLoading }">
        Create
    </a>
</template>

<script>
    export default {
        data () {
            return {
                isLoading: false
            }
        },
        methods: {
            submitForm() {
                this.$store.dispatch('createNewPricePlan').then(() => {
                    this.$router.push({ path: '/plans' })
                })

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/SubmitNewPlan.vue